import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// Buka form tambah otomatis bila URL berisi ?new=1 (dari Quick Access mobile)
export function useAutoOpen(open, ready = true) {
  const [sp, setSp] = useSearchParams();
  const want = sp.get("new") === "1";
  useEffect(() => {
    if (!want || !ready) return;
    open();
    const next = new URLSearchParams(sp);
    next.delete("new");
    setSp(next, { replace: true });
  }, [want, ready]); // eslint-disable-line react-hooks/exhaustive-deps
}
